// src/pages/WritePost/index.jsx (使用之前优化后的版本)
import React, { useState } from 'react';
import { Button, message, Card, Typography, Divider, Input, Select } from 'antd';
import { EditOutlined, TagsOutlined, FileTextOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './index.css';

const { Title, Text } = Typography;
const { TextArea } = Input;

const WritePost = () => {
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [tags, setTags] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const [category, setCategory] = useState(''); // 新增分类
  const navigate = useNavigate();
  const { publishPost, user } = useAuth();

  // 预设标签选项
  const presetTags = ['技术分享', '生活感悟', '学习笔记', '前端开发', '后端开发', '设计模式', '算法'];

  const handlePublish = async () => {
    // 添加验证逻辑
    if (!title.trim() || !content.trim()) {
      message.error('标题和内容不能为空！');
      return;
    }
    
    if (title.trim().length < 3) {
      message.error('标题长度不能少于3个字符！');
      return;
    }
    
    if (content.trim().length < 10) {
      message.error('内容长度不能少于10个字符！');
      return;
    }
    
    // 准备文章数据
    const postData = {
      title: title.trim(),
      content: content,
      tags: [...tags],
      category: category || '未分类', // 新增分类
      excerpt: content.substring(0, 100) + (content.length > 100 ? '...' : '')
    };
    
    // 发布文章
    try {
      const result = publishPost(postData);
      if (result.success) {
        message.success(result.message);
        
        // 重置表单
        setTitle('');
        setContent('');
        setTags([]);
        setCategory('');
        
        // 跳转到首页
        setTimeout(() => {
          navigate('/');
        }, 1000);
      } else {
        message.error(result.message || '发布失败，请重试');
      }
    } catch (error) {
      console.error('发布文章时出错:', error);
      message.error('发布失败，请重试');
    }
  };

  const handleAddTag = () => {
    if (inputValue && !tags.includes(inputValue)) {
      // 限制标签长度
      if (inputValue.length > 20) {
        message.warning('标签长度不能超过20个字符');
        setInputValue('');
        return;
      }
      
      // 限制标签数量
      if (tags.length >= 10) {
        message.warning('最多只能添加10个标签');
        setInputValue('');
        return;
      }
      
      setTags([...tags, inputValue]);
      setInputValue('');
    }
  };

  const handleRemoveTag = (tagToRemove) => {
    setTags(tags.filter(tag => tag !== tagToRemove));
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleAddTag();
    }
  };

  // 添加预设标签
  const addPresetTag = (presetTag) => {
    if (!tags.includes(presetTag)) {
      setTags([...tags, presetTag]);
    }
  };

  return (
    <div className="write-post-page">
      <div className="write-post-container">
        <div className="header-section">
          <EditOutlined className="header-icon" />
          <h1 className="write-post-title">撰写新文章</h1>
          <Text className="subtitle">分享你的想法和经验</Text>
        </div>
        
        <Card 
          className="main-card"
          bodyStyle={{ padding: '2rem' }}
        >
          {/* 文章标题 */}
          <div className="form-section">
            <label htmlFor="title" className="form-label">
              <FileTextOutlined className="form-icon" />
              文章标题
            </label>
            <Input
              id="title"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="请输入文章标题"
              maxLength={100}
              className="title-input"
              size="large"
            />
            <div className="char-count">
              {title.length}/100
            </div>
          </div>

          {/* 文章分类 */}
          <div className="form-section">
            <label className="form-label">
              <span role="img" aria-label="分类">📂</span>
              文章分类
            </label>
            <Select
              placeholder="选择文章分类"
              value={category}
              onChange={setCategory}
              className="category-select"
              size="large"
              allowClear
            >
              <Select.Option value="技术分享">技术分享</Select.Option>
              <Select.Option value="生活感悟">生活感悟</Select.Option>
              <Select.Option value="学习笔记">学习笔记</Select.Option>
              <Select.Option value="产品设计">产品设计</Select.Option>
              <Select.Option value="未分类">未分类</Select.Option>
            </Select>
          </div>

          {/* 文章内容 */}
          <div className="form-section">
            <label htmlFor="content" className="form-label">
              <span role="img" aria-label="内容">📝</span>
              文章内容
            </label>
            <TextArea
              id="content"
              value={content}
              onChange={(e) => setContent(e.target.value)}
              placeholder="开始写作..."
              rows={15}
              maxLength={10000}
              className="content-textarea"
              showCount
            />
          </div>

          {/* 标签管理 */}
          <div className="form-section">
            <label className="form-label">
              <TagsOutlined className="form-icon" />
              标签
            </label>
            
            {/* 已添加的标签 */}
            <div className="added-tags">
              {tags.map((tag, index) => (
                <span key={index} className="tag-item">
                  {tag}
                  <span 
                    className="tag-remove"
                    onClick={() => handleRemoveTag(tag)}
                  >
                    ×
                  </span>
                </span>
              ))}
            </div>
            
            {/* 预设标签 */}
            <div className="preset-tags-section">
              <Text type="secondary" className="section-subtitle">常用标签:</Text>
              <div className="preset-tags">
                {presetTags.map((presetTag, index) => (
                  <Button
                    key={index}
                    size="small"
                    className="preset-tag-btn"
                    onClick={() => addPresetTag(presetTag)}
                    disabled={tags.includes(presetTag)}
                  >
                    {presetTag}
                  </Button>
                ))}
              </div>
            </div>
            
            {/* 自定义标签输入 */}
            <div className="custom-tag-input">
              <Input
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                onKeyPress={handleKeyPress}
                placeholder="输入自定义标签，按回车添加"
                className="tag-input"
                suffix={
                  <Button 
                    type="text" 
                    onClick={handleAddTag}
                    className="add-tag-btn"
                  >
                    添加
                  </Button>
                }
              />
              <Text type="secondary" className="tag-hint">
                最多可添加10个标签，每个标签不超过20个字符
              </Text>
            </div>
          </div>

          <Divider className="divider" />

          {/* 操作按钮 */}
          <div className="action-buttons">
            <Button 
              type="default"
              onClick={() => navigate('/')}
              className="action-btn secondary-btn"
            >
              返回首页
            </Button>
            <Button 
              type="primary" 
              onClick={handlePublish}
              className="action-btn primary-btn"
              size="large"
            >
              发布文章
            </Button>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default WritePost;